import React from 'react';
import PropTypes from 'prop-types';
import style from '@src/js/Style';

export default class BadgeCard extends React.Component {

    static get propTypes() {

        return {
            children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        };
    }

    render() {

        return (
            <div className={ style('bg-gray-light-alt px-6 py-4 rounded') }>
                { this.props.children }
            </div>
        );
    }

}